import React, { useState, useEffect } from 'react';
import axios from "axios";
import backendURL from "../../config";


function WhatsappConnector() {
    const [formData, setFormData] = useState({
        WHATSAPP_VERIFY_TOKEN: '',
        WHATSAPP_ACCESS_TOKEN: '',
        WHATSAPP_PHONE_NUMBER_ID: '',
        WHATSAPP_NUMBER: '',
        WHATSAPP_BUSINESS_ACCOUNT_ID: ''
    });

    const [responseMessage, setResponseMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');

    const callbackURL = "https://klonit-api-klonit.f6qcwr.easypanel.host/wa-webhook";
    const verifyToken = "KLONIT_VERIFY_TOKEN";

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setResponseMessage('');
        setErrorMessage('');

        try {
            const token = localStorage.getItem("access_token");
            const headers = { Authorization: `Bearer ${token}` };

            const response = await axios.post(`${backendURL}/add-whatsapp`, formData, { headers });

            if (response.status >= 200 && response.status < 300) {
                setResponseMessage(response.data.message);
                fetchDataExists(); // Refresh data after submitting
            } else {
                setErrorMessage(response.data.message || `Error: ${response.status}`);
            }
        } catch (error) {
            setErrorMessage('Failed to connect to server.');
            console.error("Error submitting WhatsApp data:", error);
        }
    };

    const fetchDataExists = async () => {
        try {
            const token = localStorage.getItem("access_token");
            const headers = { Authorization: `Bearer ${token}` };
            const response = await axios.get(`${backendURL}/get-whatsapp`, { headers });
            const responseData = typeof response.data.data === 'string' ? JSON.parse(response.data.data) : response.data.data;
            if (Object.keys(responseData).length > 0) {
				setFormData({
                    WHATSAPP_VERIFY_TOKEN: responseData.whatsapp_verify_token || '',
                    WHATSAPP_ACCESS_TOKEN: responseData.whatsapp_access_token || '',
                    WHATSAPP_PHONE_NUMBER_ID: responseData.whatsapp_phone_number_id || '',
                    WHATSAPP_NUMBER: responseData.whatsapp_phone_number || '',
                    WHATSAPP_BUSINESS_ACCOUNT_ID: responseData.whatsapp_business_account_id || ''
                });
			}else {
                setFormData({
                    WHATSAPP_VERIFY_TOKEN: '',
                    WHATSAPP_ACCESS_TOKEN: '',
                    WHATSAPP_PHONE_NUMBER_ID: '',
                    WHATSAPP_NUMBER: '',
                    WHATSAPP_BUSINESS_ACCOUNT_ID: ''
                });
            }
        } catch (error) {
            console.error("Error fetching WhatsApp data:", error);
            setErrorMessage('Error fetching WhatsApp data.');
        }
    };

    useEffect(() => {
        fetchDataExists();
    }, []);


    const copyToClipboard = (text) => {
        navigator.clipboard.writeText(text)
            .then(() => {
                alert('Copied to clipboard!'); // You can replace this with a more elegant notification
            })
            .catch(err => {
                console.error('Failed to copy text: ', err);
                alert('Failed to copy text. Please try again.');
            });
    };

    return (
        <div>
            <main className="content">
                <div className="container-fluid p-0">
                    <div className="mb-3">
                        <h1 className="h3 d-inline align-middle"> <strong>Connect </strong> WhatsApp</h1>
                    </div>
                    <div className="row">
                        <div className="col-12 col-lg-12">
                            <div className="card">
                                <div className="card-header">
                                    <h5 className="card-title mb-0">WhatsApp Integration Setup</h5>
                                </div>
                                <div className="card-body">
                                    <div className='row'>
                                        <div className='col-md-8'>
                                            <form onSubmit={handleSubmit}>
                                                <div>
                                                    <label htmlFor="WHATSAPP_ACCESS_TOKEN">WhatsApp Access Token:</label>
                                                    <input
                                                        type="text"
                                                        id="WHATSAPP_ACCESS_TOKEN"
                                                        name="WHATSAPP_ACCESS_TOKEN"
                                                        value={formData.WHATSAPP_ACCESS_TOKEN}
                                                        onChange={handleChange}
                                                        required
                                                        placeholder='WhatsApp Access Token'
                                                    />
                                                </div>
                                                <div>
                                                    <label htmlFor="WHATSAPP_PHONE_NUMBER_ID">WhatsApp Phone Number ID:</label>
                                                    <input
                                                        type="text"
                                                        id="WHATSAPP_PHONE_NUMBER_ID"
                                                        name="WHATSAPP_PHONE_NUMBER_ID"
                                                        value={formData.WHATSAPP_PHONE_NUMBER_ID}
                                                        onChange={handleChange}
                                                        required
                                                        placeholder="WhatsApp Phone Number ID"
                                                    />
                                                </div>
                                                <div>
                                                    <label htmlFor="WHATSAPP_BUSINESS_ACCOUNT_ID">WhatsApp Business Account ID:</label>
                                                    <input
                                                        type="text"
                                                        id="WHATSAPP_BUSINESS_ACCOUNT_ID"
                                                        name="WHATSAPP_BUSINESS_ACCOUNT_ID"
                                                        value={formData.WHATSAPP_BUSINESS_ACCOUNT_ID}
                                                        onChange={handleChange}
                                                        required
                                                        placeholder='WhatsApp Business Account ID'
                                                    />
                                                </div>
                                                <div>
                                                    <label htmlFor="WHATSAPP_NUMBER">WhatsApp Number:</label>
                                                    <input
                                                        type="text"
                                                        id="WHATSAPP_NUMBER"
                                                        name="WHATSAPP_NUMBER"
                                                        value={formData.WHATSAPP_NUMBER}
                                                        onChange={handleChange}
                                                        required
                                                        placeholder='WhatsApp number with country code'
                                                    />
                                                </div>
                                                <div>
                                                    <label htmlFor="WHATSAPP_VERIFY_TOKEN">WhatsApp Verify Token:</label>
                                                    <input
                                                        type="text"
                                                        id="WHATSAPP_VERIFY_TOKEN"
                                                        name="WHATSAPP_VERIFY_TOKEN"
                                                        value={formData.WHATSAPP_VERIFY_TOKEN}
                                                        onChange={handleChange}
                                                        required
                                                        placeholder='WhatsApp Verify Token'
                                                    />
                                                </div>
                                                <button className='btn btn-primary' type="submit">Connect with WhatsApp</button>
                                            </form>
                                        </div>
                                        <div className='col-md-4'>
                                            <h3>Callback URL:</h3>
                                            <p className='copy-callback'>
                                                {callbackURL}
                                                <i className="fa fa-copy copy-icon" onClick={() => copyToClipboard(callbackURL)} aria-hidden="true"></i>
                                            </p>
                                            <br/>
                                            <h3>Verify token:</h3>
                                            <p className='copy-token'>
                                                {verifyToken}
                                                <i className="fa fa-copy copy-icon" onClick={() => copyToClipboard(verifyToken)} aria-hidden="true"></i>
                                            </p>
                                        </div>
                                    </div>

                                    <br />
                                    {responseMessage && <div className="alert alert-info">{responseMessage}</div>}
                                    {errorMessage && <div className="alert alert-danger">{errorMessage}</div>}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    );
}

export default WhatsappConnector;